import React from 'react'
import './deadlines.css'

function Deadlines(){
    return <div className="deadlines">
        <li><a href="google.com">Deadlines</a></li>.
        <li><a href="google.com">Calculators</a></li>
    </div>
}
export default Deadlines